import { gql } from "@apollo/client";

const VERIFY_CODE = gql`
  mutation verifyCode($email: String!, $randomCode: String!) {
    verifyCode(email: $email, randomCode: $randomCode) {
      name
      id
      designation {
        name
        paneltype
      }
      mainSuperAdminId
      accessToken
      refreshToken
      username
      email
      verified
      number
      picture
      pseudonym
      stripe_id
      plans
      hasTrial
      endDate
    }
  }
`;
export default VERIFY_CODE;
